const HomePage = () => window.location.replace('https://hacktiv8.com');

export default HomePage;
